<template>
    <div class="board" id="board">
        <div v-hasPermi="['questionBank:question:batch']" class="h100p">
            <div class="title">
                <span>
                    <el-button
                            type="text"
                            icon="el-icon-arrow-left"
                            @click="$router.push({ name: 'question', query: { id: $route.query.id}})">
                        {{ verificationTextConfig.back }}
                    </el-button>
                    <el-divider direction="vertical"></el-divider>
                    <span class="name" style="margin-right: 20px">{{ verificationTextConfig.title }}</span>

                    <span>
                        <span style="margin-left: 20px">
                            {{ questionTypeFormatter('single_choice') }}：
                            <span style="color: #0070DE">
                                {{ overview.single_choice_num }}
                            </span>
                        </span>
                        <span style="margin-left: 20px">
                            {{ questionTypeFormatter('choice') }}：
                            <span style="color: #0070DE">
                                {{ overview.choice_num }}
                            </span>
                        </span>
                        <span style="margin-left: 20px">
                            {{ questionTypeFormatter('uncertain_choice') }}：
                            <span style="color: #0070DE">
                                {{ overview.uncertain_choice_num }}
                            </span>
                        </span>
                        <span style="margin-left: 20px">
                            {{ questionTypeFormatter('determine') }}：
                            <span style="color: #0070DE">
                                {{ overview.determine_num }}
                            </span>
                        </span>
                        <span style="margin-left: 20px">
                            {{ questionTypeFormatter('fill') }}：
                            <span style="color: #0070DE">
                                {{ overview.fill_num }}
                            </span>
                        </span>
                        <span style="margin-left: 20px">
                            {{ questionTypeFormatter('subjectivity') }}：
                            <span style="color: #0070DE">
                                {{ overview.subjectivity_num }}
                            </span>
                        </span>
                    </span>
                </span>
                <el-tooltip class="item" effect="dark" placement="bottom">
                    <div slot="content">
                        {{ verificationTextConfig.screen }}<br/>
                        {{ verificationTextConfig.screenTip }}
                    </div>
                    <el-button
                            type="text"
                            icon="el-icon-full-screen"
                            @click="requestFullScreen()"
                            style="line-height:0px;font-size:20px;padding:0">
                    </el-button>
                </el-tooltip>
            </div>
            <div class="questionCon" v-loading="loading" element-loading-text="加载中"
                 element-loading-spinner="el-icon-loading">
                <el-form class="left" label-position="left">
                    <el-card v-for="(e,i) in question" :key="i+num" :id="'questionCard'+i" class="box-card"
                             shadow="hover" :style="e.is_valid?'':'border-color:rgb(245, 108, 108)'">
                        <p v-if="e.invalid_notice" v-html="e.invalid_notice" class="ql-editor"
                           style="color:rgb(245, 108, 108);margin:0 45px 5px;font-weight:600;font-size:15px"></p>
                        <p v-for="(err,n) in e.error" :key="n"
                           style="color:rgb(245, 108, 108);margin:0 45px 5px;font-weight:600;font-size:15px">
                            {{ err }}</p>
                        <br/>
                        <!-- 编辑模块 -->
                        <div v-if="!e.disabled">
                            <el-form-item label="评阅方式" label-width="70px" v-if="e.type === 'subjectivity'">
                                <el-radio v-model="e.review_mode" v-for="item in reviewModeOptions" :key="item.id" :label="item.dict_value" @change="reviewModeChange(i)" style="display:block;padding-top:15px">
                                    {{ item.dict_label }}
                                </el-radio>
                            </el-form-item>
                            <el-form-item label="评阅脚本" label-width="70px" v-if="e.type === 'subjectivity'&& e.review_mode === 'script'">
                                <el-input
                                    type="textarea"
                                    v-model="e.review_script"
                                    show-word-limit
                                    style="width: 100%"
                                ></el-input>
                            </el-form-item>
                            <el-form-item label-width="45px">
                                <template slot="label">
                                    <span class="number">{{ i + 1 }}</span>
                                </template>
                                <quill-editor
                                        class="editor"
                                        :value.sync="e.stem"
                                        :fill="e.type == 'fill'"
                                        :placeholder="formTextConfig.stemTip">
                                </quill-editor>
                                <p class="info" v-if="e.type == 'fill'">{{ formTextConfig.fillTip }}</p>
                            </el-form-item>
                            <el-form-item label-width="45px">
                                <el-tag v-if="e.attachment.stem" :key="num" :closable="true" :disable-transitions="true"
                                        @close="e.attachment.stem=undefined,num+=1" size="medium">
                                    {{ formTextConfig.stemAttachment }}：{{ e.attachment.stem.file_name }}
                                </el-tag>
                                <el-button v-else @click="enclosure=0,importDialogVisible=true" size="mini"
                                           type="primary" plain>{{ formTextConfig.stemAttachmentUpload }}
                                </el-button>
                            </el-form-item>
                            <el-form-item label="答题方式" label-width="70px" v-if="e.type == 'subjectivity'">
                                <el-checkbox-group v-model="e.submit_mode" :disabled="e.review_mode === 'script'">
                                    <el-checkbox v-for="item in submitModeOptions" :label="item.dict_value" :key="item.id">{{ item.dict_label }}</el-checkbox>
                                </el-checkbox-group>
                            </el-form-item>
                            <el-form-item label-width="45px" :label="formTextConfig.crosshead"
                                          v-if="e.type == 'subjectivity' && e.crosshead.length"
                                          style="margin-left:45px;">
                                <div v-for="(q,j) in e.crosshead" :key="j+num">
                                    <el-form-item label-width="45px" :label="'（'+(j+1)+'）'">
                                        <el-row style="display:flex;">
                                            <quill-editor
                                                    class="editor" :value.sync="q.stem"
                                                    :placeholder="formTextConfig.crossheadTip.signMix(j + 1)">
                                            </quill-editor>
                                            <el-button
                                                    type="danger" plain size="mini" icon="el-icon-delete"
                                                    @click="e.crosshead.splice(j,1),num+=1">
                                            </el-button>
                                        </el-row>
                                    </el-form-item>
                                    <el-form-item :label="formTextConfig.score" label-width="45px">
                                        <el-input-number
                                                @blur="changeScore(i)" v-model="q.score" :min="0" :step="0.1"
                                                step-strictly>
                                        </el-input-number>
                                    </el-form-item>
                                </div>
                            </el-form-item>
                            <el-form-item label-width="45px" v-if="e.type == 'subjectivity'">
                                <el-button
                                        type="primary" plain
                                        @click="e.crosshead.push({stem:'',score:2}),changeScore(i)"
                                        style="width:100%">{{ formTextConfig.addCrosshead }}
                                </el-button>
                            </el-form-item>

                            <el-radio-group
                                    v-model="e.answer[0]" style="margin:15px 0 0 45px"
                                    v-if="e.type == 'single_choice'">
                                <el-form-item
                                        v-for="(f,j) in e.choices" :key="j+num"
                                        :label-width="e.type == 'single_choice'?'50px':'30px'">
                                    <template slot="label">
                                        <el-radio :label="j"><i>{{ letter[j] }}.</i></el-radio>
                                    </template>
                                    <el-row style="display: flex;">
                                        <quill-editor
                                                class="editor" :value.sync="e.choices[j]"
                                                :placeholder="answerTextConfig.formatter.signMix(letter[j])">
                                        </quill-editor>
                                        <el-button
                                                type="danger" plain size="mini" icon="el-icon-delete"
                                                @click="e.choices.splice(j,1),num+=1"
                                                v-if="e.choices.length>3">
                                        </el-button>
                                    </el-row>
                                </el-form-item>
                            </el-radio-group>
                            <el-radio-group v-model="e.answer[0]" v-if="e.type == 'determine'" class="determine">
                                <el-form-item label-width="50px">
                                    <el-radio :label="1">{{ answerTextConfig.determine.right }}</el-radio>
                                </el-form-item>
                                <el-form-item label-width="50px">
                                    <el-radio :label="0">{{ answerTextConfig.determine.error }}</el-radio>
                                </el-form-item>
                            </el-radio-group>
                            <el-checkbox-group
                                    v-model="e.answer" style="margin:15px 0 0 45px"
                                    v-if="e.type == 'choice' || e.type == 'uncertain_choice'">
                                <el-form-item v-for="(f,j) in e.choices" :key="j+num" label-width="50px">
                                    <template slot="label">
                                        <el-checkbox :label="j"><i>{{ letter[j] }}.</i></el-checkbox>
                                    </template>
                                    <el-row style="display: flex;">
                                        <quill-editor
                                                class="editor" :value.sync="e.choices[j]"
                                                :placeholder="answerTextConfig.formatter.signMix(letter[j])">
                                        </quill-editor>
                                        <el-button
                                                type="danger" plain size="mini" icon="el-icon-delete"
                                                @click="e.choices.splice(j,1),num+=1"
                                                v-if="e.choices.length>3">
                                        </el-button>
                                    </el-row>
                                </el-form-item>
                            </el-checkbox-group>
                            <el-form-item
                                    label-width="45px"
                                    v-if="(e.type == 'single_choice' || e.type == 'choice' || e.type == 'uncertain_choice') && (e.choices.length<letter.length)">
                                <el-button
                                        type="primary" plain @click="e.choices.push('')"
                                        style="width:100%">{{ answerTextConfig.add }}
                                </el-button>
                            </el-form-item>
                            <div v-if="e.type == 'subjectivity'" style="margin-bottom:18px">
                                <el-form-item
                                        :label="answerTextConfig.name" label-width="40px"
                                        style="margin-left:45px">
                                    <quill-editor
                                            class="editor" :value.sync="e.answer[0]"
                                            :placeholder="answerTextConfig.inputTip"></quill-editor>
                                </el-form-item>
                                <el-form-item label-width="85px">
                                    <el-tag
                                            v-if="e.attachment.answer" :key="num" :closable="true"
                                            :disable-transitions="true" @close="e.attachment.answer=undefined,num+=1"
                                            size="medium">
                                        {{ answerTextConfig.attachment }}：{{ e.attachment.answer.file_name }}
                                    </el-tag>
                                    <el-button
                                            v-else @click="enclosure=1,importDialogVisible=true" size="mini"
                                            type="primary" plain>{{ answerTextConfig.upload }}
                                    </el-button>
                                </el-form-item>
                            </div>

                            <el-form-item :label="formTextConfig.analysis" label-width="40px" style="margin-left:45px">
                                <quill-editor
                                        class="editor" :value.sync="e.analysis"
                                        :placeholder="formTextConfig.analysisTip"></quill-editor>
                            </el-form-item>
                            <el-form-item label-width="85px">
                                <el-tag v-if="e.attachment.analysis" :key="num" :closable="true"
                                        :disable-transitions="true" @close="e.attachment.analysis=undefined,num+=1"
                                        size="medium">{{
                                    formTextConfig.analysisAttachment
                                    }}：{{ e.attachment.analysis.file_name }}
                                </el-tag>
                                <el-button v-else @click="enclosure=2,importDialogVisible=true" size="mini"
                                           type="primary" plain>{{ formTextConfig.analysisAttachmentUpload }}
                                </el-button>
                            </el-form-item>
                        </div>
                        <div v-if="!e.disabled" >
                            <el-form-item :label="formTextConfig.training" label-width="70px"
                                          v-if="e.type == 'subjectivity' && trainingEnable">
                                <el-select v-model="question[i].training_label"
                                           :placeholder="formTextConfig.trainingTip" @change="trainingChange($event,e,i)">
                                    <el-option :label="formTextConfig.nullTraining" :value="formTextConfig.nullTraining"></el-option>
                                    <el-option v-for="g in trainingOptions" :key="g.label" :label="g.label"
                                               :value="g.label"  v-if="e.review_mode=='manual'|| g.platform_mark=='ws_cloud'"></el-option>
                                </el-select>
                            </el-form-item>
                            <div  class="specifications-list-container" v-if="show_project_url || has_bill">
                                <el-form-item :label="formTextConfig.projectUrl" label-width="70px" v-if="e.type == 'subjectivity' && trainingEnable && show_project_url">
                                    <el-input v-model="project_url" :placeholder="formTextConfig.projectUrlTip"></el-input>
                                </el-form-item>
                                <el-form-item :label="formTextConfig.specification" label-width="70px" v-if="e.type == 'subjectivity' && trainingEnable && has_bill">
                                    <ul class="specifications-list">
                                        <li :class="item.id == specification_id?'selected':''"  v-for="item in specificationList" @click="changeSpecification(item,e)">
                                            <h5>{{item.title}}</h5>
                                            <p><span class="label">{{formTextConfig.cpuCores}}</span>{{item.cpuCores}}核</p>
                                            <p><span class="label">{{formTextConfig.memory}}</span>{{item.memory}}MB</p>
                                            <p><span class="label">{{formTextConfig.provider}}</span>{{item.provider}}</p>
                                            <p><span class="label">{{formTextConfig.price}}</span>{{item.currentPrice ?item.currentPrice:item.price}}元 /
                                                {{item.priceUnit=="min"?"分钟":"小时"}}</p>
                                            <i class="selected-icon es-icon es-icon-done"></i>
                                        </li>
                                    </ul>
                                </el-form-item>
                                <el-form-item :label="formTextConfig.giftDuration" label-width="70px" v-if="e.type == 'subjectivity' && trainingEnable && has_bill">
                                    <el-row>
                                        <el-col :span="18">
                                            <el-input type="number" v-model="gift_duration" :placeholder="formTextConfig.giftDurationTip" @input="changeGiveDuration()" ></el-input>
                                        </el-col>
                                        <el-col :span="6" style="padding-left:10px">
                                            <span>{{priceUnitLabel}}</span>
                                        </el-col>
                                    </el-row>
                                </el-form-item>
                                <el-form-item label="" label-width="70px" v-if="e.type == 'subjectivity' && trainingEnable && has_bill">
                                    <span>将在ModelEasy平台获赠{{tipdm_icon}}泰迪币</span>
                                </el-form-item>
                            </div>
                            <el-form-item :label="formTextConfig.difficulty" label-width="70px">
                                <el-radio-group v-model="question[i].difficulty">
                                    <el-radio v-for="d in difficultyOptions" :key="d.dict_value" :label="d.dict_value"
                                              style="margin-right:16px">{{ d.dict_label }}
                                    </el-radio>
                                </el-radio-group>
                            </el-form-item>
                            <el-form-item :label="formTextConfig.tag" label-width="70px">
                                <el-cascader v-model="tags" :options="tagOptions" :props="tagProps" :ref="'cascader'+i"
                                             @change="changeTags(i)" filterable clearable
                                             style="width:100%"></el-cascader>
                            </el-form-item>
                            <el-form-item
                                    :label="(e.type == 'subjectivity' && e.crosshead.length) ? formTextConfig.totalScore:formTextConfig.score"
                                    label-width="70px">
                                <el-input-number v-if="e.type == 'subjectivity' && e.crosshead.length" disabled
                                                 v-model="question[i].score" :min="0" :step="0.1"
                                                 step-strictly></el-input-number>
                                <el-input-number v-else v-model="question[i].score" :min="0" :step="0.1"
                                                 step-strictly></el-input-number>
                                <p class="info" v-if="e.type == 'subjectivity' && e.crosshead.length">
                                    {{ formTextConfig.scoreTip }}</p>
                            </el-form-item>
                            <!-- <el-form-item label="分值" label-width="70px">
                                <el-input-number v-model="question[i].score" :min="0.5" :step="0.5" step-strictly></el-input-number>
                            </el-form-item> -->
                            <el-form-item
                                    :label="formTextConfig.type" label-width="70px"
                                    v-if="e.type == 'single_choice' || e.type == 'choice' || e.type == 'uncertain_choice'">
                                <el-select
                                        v-model="e.type" @change="typeChange(e.type,i)"
                                        :placeholder="formTextConfig.typeTip">
                                    <el-option
                                            v-for="item in typeList"
                                            v-if="item.dict_value == 'single_choice' || item.dict_value == 'choice' || item.dict_value == 'uncertain_choice'"
                                            :key="item.dict_value"
                                            :value="item.dict_value"
                                            :label="item.dict_label">
                                    </el-option>
                                </el-select>
                            </el-form-item>
                        </div>
                        <el-form-item v-if="!e.disabled" style="margin:45px 0 0 45px">
                            <el-button type="primary" @click="save(i),num+=1">{{ formTextConfig.save.name }}</el-button>
                            <el-button @click="cancel(i)">{{ formTextConfig.cancel }}</el-button>
                        </el-form-item>
                        <div class="editModel">
                            <el-button
                                    v-show="e.disabled"
                                    type="primary"
                                    icon="el-icon-edit-outline"
                                    @click="clickEdit(i),num+=1">
                                {{ formTextConfig.edit.name }}
                            </el-button>
                            <el-button
                                    type="danger"
                                    icon="el-icon-delete"
                                    @click="clickRemove(i)">
                                {{ formTextConfig.delete.name }}
                            </el-button>
                        </div>

                        <!-- 预览模块 -->
                        <div v-if="e.disabled" class="preview">
                            <el-form-item label-width="60px">
                                <template slot="label">
                                    <span class="number">{{ i + 1 }}</span>
                                </template>
                                <div v-html="e.stemPreview" class="ql-editor" style="display:inline-flex"></div>
                            </el-form-item>
                            <div v-if="e.crosshead">
                                <el-form-item v-for="(n,l) in e.crosshead" :key="l" :label="'（'+(l+1)+'）'"
                                              label-width="58px" style="margin-left:58px">
                                    <div v-html="n.stem" class="ql-editor" style="display:inline-flex"></div>
                                </el-form-item>
                            </div>
                            <el-form-item label-width="60px">
                                <el-tag v-if="e.attachment.stem" size="medium"><a
                                        :href="config_env.BASE_URL+getDownloadAddress(e.attachment.stem.file_path,e.attachment.stem.file_name)"
                                        target="_blank"><i class="el-icon-download"></i> {{ formTextConfig.attachment }}
                                    {{ e.attachment.stem.file_name }}</a></el-tag>
                            </el-form-item>
                            <el-form-item label-width="60px" v-if="e.type == 'subjectivity' && e.training_mirror">
                                <el-button
                                        disabled
                                        type="primary"
                                        size="mini"
                                        icon="el-icon-monitor">
                                    {{ e.training_label }}
                                </el-button>
                            </el-form-item>
                            <el-form-item label-width="60px" label=""
                                          v-if="e.type != 'fill' && e.type != 'subjectivity'">
                                <el-radio-group disabled v-model="e.answer[0]" v-if="e.type == 'single_choice'">
                                    <el-radio
                                            v-for="(f,j) in e.choices" :key="j" :label="j"
                                            style="display:block;line-height:40px;">
                                        <i>{{ letter[j] }} .&nbsp;&nbsp;</i>
                                        <span v-html="f" class="ql-editor" style="display:inline-flex"></span>
                                    </el-radio>
                                </el-radio-group>
                                <el-radio-group disabled v-model="e.answer[0]" v-if="e.type == 'determine'"
                                                class="determine">
                                    <el-form-item label-width="50px">
                                        <el-radio :label="1">{{ answerTextConfig.determine.right }}</el-radio>
                                    </el-form-item>
                                    <el-form-item label-width="50px">
                                        <el-radio :label="0">{{ answerTextConfig.determine.error }}</el-radio>
                                    </el-form-item>
                                </el-radio-group>
                                <el-checkbox-group
                                        disabled v-model="e.answer"
                                        v-if="e.type == 'choice' || e.type == 'uncertain_choice'">
                                    <el-checkbox
                                            v-for="(f,j) in e.choices" :key="j" :label="j"
                                            style="display:block;line-height:40px;">
                                        <i>{{ letter[j] }} .&nbsp;&nbsp;</i>
                                        <span v-html="f" class="ql-editor" style="display:inline-flex"></span>
                                    </el-checkbox>
                                </el-checkbox-group>
                            </el-form-item>
                            <div v-if="e.type === 'subjectivity'">
                                <el-form-item  v-if="e.submit_mode && e.submit_mode.includes('text')" label-width="90px" style="margin-left:58px" :label="formTextConfig.yourAnswer+':'">
                                    <div class="subjectivity">
                                        <div v-if="e.crosshead.length>0">
                                            <div v-for="(n,l) in e.crosshead" :key="l"
                                                 style="margin-bottom:10px !important">
                                                <span class="questIndex">（{{ (l + 1) }}）&nbsp;</span>
                                                <quill-editor
                                                              :placeholder="formTextConfig.crossheadAnswerTip.signMix(l+1)"
                                                              style="display:inline-block;width:calc(100% - 48px);margin-top:7px"></quill-editor>
                                            </div>
                                        </div>
                                        <quill-editor v-else
                                                       :placeholder="formTextConfig.answerTip"
                                                      style="margin-bottom:10px !important;margin-top:6px"></quill-editor>
                                    </div>
                                </el-form-item>
                                <el-form-item  v-if="e.submit_mode && e.submit_mode.includes('link')" label-width="90px" style="margin-left:58px" :label="formTextConfig.link+':'">
                                        <div  class="subjectivity">
                                            <el-input v-model="link" :placeholder="formTextConfig.linkTip"></el-input>
                                        </div>
                                </el-form-item>
                                <el-form-item v-if="e.submit_mode && e.submit_mode.includes('attachment')" label-width="90px" style="margin-left:58px" :label="e.submit_mode && e.submit_mode.includes('attachment') && e.submit_mode.length == 1 ?formTextConfig.yourAnswer+':' :''">
                                    <div   class="subjectivity">
                                        <el-button disabled size="mini" type="primary" icon="el-icon-paperclip" style="margin-top:10px;">{{ formTextConfig.uploadTip }}
                                        </el-button>
                                    </div>
                                </el-form-item>
                            </div>
                            <hr size="1" dashed="dashed" style="border-top:1px #ddd dashed;margin:15px 0">
                            <div v-if="e.type === 'subjectivity'">
                                <el-form-item label="评阅方式：" label-width="90px" style="margin-left:58px">
                                    {{ reviewModelFormatter(e.review_mode) }}
                                </el-form-item>
                                <el-form-item label="脚本代码：" v-if="e.review_mode === 'script'" label-width="90px" style="margin-left:58px">
                                    <p v-html="e.review_script" class="ql-editor" style="max-height: 300px; overflow-y: auto; margin-bottom: 10px"></p>
                                </el-form-item>
                                <el-form-item label="实操环境：" label-width="90px" style="margin-left:58px">
                                    {{ e.training_label }}
                                </el-form-item>
                                <el-form-item label="答题方式：" label-width="90px" style="margin-left:58px">
                                    {{ submitModeFormatter(e) }}
                                </el-form-item>
                            </div>

                            <el-form-item
                                    :label="(e.type == 'subjectivity' && e.crosshead.length) ? formTextConfig.totalScore + '：':formTextConfig.score + '：'"
                                    @blur="!e.score?e.score = 2 : ''" label-width="90px" style="margin-left:58px">
                                {{ formTextConfig.scoreFormatter.signMix(e.score) }}
                            </el-form-item>
                            <el-form-item :label="formTextConfig.difficulty + '：'" label-width="90px" style="margin-left:58px">
                                {{ difficultyFormatter(e.difficulty) }}
                            </el-form-item>
                            <el-form-item :label="formTextConfig.tag + '：'" label-width="90px" style="margin-left:58px">
                                <el-tag v-for="(k,l) in e.tags" :key="l" style="margin-right:10px">{{ k.name }}</el-tag>
                            </el-form-item>
                            <el-form-item :label="answerTextConfig.name + '：'" label-width="90px" style="margin-left:58px"
                                          v-if="e.type == 'subjectivity'">
                                <p v-html="e.answer[0]" class="ql-editor"></p>
                                <el-tag v-if="e.attachment.answer" size="medium">
                                    <a :href="config_env.BASE_URL+getDownloadAddress(e.attachment.answer.file_path,e.attachment.answer.file_name)"
                                        target="_blank">
                                        <i class="el-icon-download"></i>
                                        {{ answerTextConfig.attachment }}
                                        {{ e.attachment.answer.file_name }}
                                    </a>
                                </el-tag>
                            </el-form-item>
                            <el-form-item :label="answerTextConfig.name + '：'" label-width="90px" style="margin-left:58px" v-else>
                                {{ change(e.answer, e.type) }}
                            </el-form-item>
                            <el-form-item :label="formTextConfig.analysis + '：'" label-width="90px" style="margin-left:58px">
                                <div v-html="e.analysis" class="ql-editor" style="display:inline-flex"></div>
                                <br/>
                                <el-tag v-if="e.attachment.analysis" size="medium">
                                    <a :href="config_env.BASE_URL+getDownloadAddress(e.attachment.analysis.file_path,e.attachment.analysis.file_name)"
                                        target="_blank">
                                        <i class="el-icon-download"></i>
                                        {{ formTextConfig.analysisAttachment }}
                                        {{ e.attachment.analysis.file_name }}
                                    </a>
                                </el-tag>
                            </el-form-item>
                        </div>
                    </el-card>
                </el-form>
                <div class="right">
                    <el-card class="box-card" shadow="hover">
                        <div style="font-weight:600">
                            {{ operateTextConfig.questionList }}
                            <span style="color:#F56C6C" v-show="errorNum>0">
                                {{ operateTextConfig.questionListTip.signMix(errorNum) }}
                            </span>
                        </div>
                        <div style="height:calc(100% - 70px);overflow:auto">
                            <el-row>
                                <el-col :span="8" v-for="(e,i) in question" :key="i">
                                    <a class="questionButton">
                                        <el-button
                                                :class="['questionA',{'questionCheck':operation&&e.ischeck?true:false},{'questionEdit':e.disabled?false:true},{'questionError':e.is_valid?false:true}]"
                                                @click="clickQuestion(i)">
                                            <span class="check" v-show="operation&&e.ischeck"><i
                                                    class="el-icon-check"></i></span><span
                                                class="number">{{ i + 1 }}</span>
                                            <p>{{ e.type|formatType(typeList) }}</p>
                                        </el-button>
                                    </a>
                                </el-col>
                            </el-row>
                        </div>
                        <el-button v-show="!operation" @click="setOperation" type="primary" plain
                                   style="width:100%;margin-top:10px">{{ operateTextConfig.batch }}
                        </el-button>
                        <div v-show="operation">
                            <el-button type="text" @click="selectAll" style="margin:9px 11px 0">
                                {{ select ? operateTextConfig.noSelectAll : operateTextConfig.selectAll }}
                            </el-button>
                            <el-row>
                                <el-col :span="8">
                                    <el-button type="text" @click="openDialog(0)" style="width:100%">
                                        {{ operateTextConfig.button.setDifficulty.name }}
                                    </el-button>
                                </el-col>
                                <el-col :span="8">
                                    <el-button type="text" @click="openDialog(1)" style="width:100%">
                                        {{ operateTextConfig.button.setScore.name }}
                                    </el-button>
                                </el-col>
                                <el-col :span="8">
                                    <el-button type="text" @click="batchDelete" style="width:100%">
                                        {{ operateTextConfig.button.delete.name }}
                                    </el-button>
                                </el-col>
                            </el-row>
                            <el-button @click="operation = !operation" type="primary" plain
                                       style="margin-top:8px;width:100%">
                                {{ operateTextConfig.button.ok }}
                            </el-button>
                        </div>
                    </el-card>
                    <el-button v-show="!operation" @click="importQuestion" type="primary" style="width:100%">
                        {{ operateTextConfig.button.confirm.name }}
                    </el-button>
                </div>
            </div>
            <set-dialog :setDifficultyShow.sync="difficultyDialogVisible" :setScoreShow.sync="scoreDialogVisible"
                        :row="selectRow" @difficultyDialogClose="difficultyDialogClose"
                        @scoreDialogClose="scoreDialogClose"></set-dialog>
            <file-upload :show.sync="importDialogVisible" @close="close"></file-upload>
        </div>
    </div>
</template>

<script>
import quillEditor from '@/components/editor/index.vue'
import setDialog from './dialog/set.vue'
import fileUpload from '../../components/fileUpload/index.vue'
import {getDownloadAddress} from '@/utils/common.js'
import {getDict} from "@/api/dict";
import {getSpecificationList} from "@/api/specification.js";

export default {
    components: {
        quillEditor, setDialog, fileUpload
    },
    data() {
        return {
            operation: false,
            select: false,
            letter: ['A', 'B', 'C', 'D', 'E', 'F', 'G', 'H', 'I', 'J', 'K', 'L', 'M', 'N', 'O', 'P', 'Q', 'R', 'S', 'T', 'U', 'V', 'W', 'X', 'Y', 'Z'],
            question: [],
            errorNum: 0,
            overview: {},
            typeList: [],
            difficultyOptions: [],
            trainingOptions: [],
            tags: [],
            tagProps: {multiple: true, expandTrigger: 'hover', emitPath: false, value: 'id', label: 'name'},
            tagOptions: [],
            waitSave: true,
            storage: null,
            num: 0,
            selectRow: [],
            difficultyDialogVisible: false,
            scoreDialogVisible: false,
            setDialogData: [],
            loading: true,
            importDialogVisible: false,
            enclosure: 0,
            questionIndex: 0,
            reviewModeOptions: [],
            submitModeOptions: [],
            specificationList: [],
            show_project_url: false,
            project_url: '',
            has_bill: false,
            priceUnitLabel: '',
            specification_id: null,
            gift_duration: null,
            tipdm_icon:"",
            price: null,
            link:null
        }
    },
    computed: {
        trainingEnable() {
            return this.$store.state.global.textConfig.training.enable
        },
        verificationTextConfig() {
            return this.$store.state.global.textConfig.backend.verification
        },
        formTextConfig() {
            return this.verificationTextConfig.form
        },
        answerTextConfig() {
            return this.formTextConfig.answer
        },
        saveTextConfig() {
            return this.formTextConfig.save
        },
        operateTextConfig() {
            return this.verificationTextConfig.operate
        },
    },
    created() {
        getDict('submit_mode').then(res => {
            this.submitModeOptions = res.data
        })
        getDict('review_mode').then(res => {
            this.reviewModeOptions = res.data.filter(item => item.dict_value !== 'objective')
        })
        getSpecificationList().then(res => {
            this.specificationList = res.data
        })
        this.$store.dispatch("getDict", 'question_difficulty').then(res => {
            this.difficultyOptions = res.data
        });
        if (this.trainingEnable) {
            this.$store.dispatch("getTrainingMirrorList").then(res => {
                this.trainingOptions = res.data
            });
        }
        this.$store.dispatch("getQuestionTagList").then(res => {
            this.tagOptions = []
            for (let i = 0; i < res.data.length; i++) {
                const e = res.data[i];
                if (i != (res.data.length - 1)) {
                    this.tagOptions.push(e)
                } else {
                    this.tagOptions.push(...e.children)
                }
            }
        });
        this.$store.dispatch("getDict", 'question_type').then(res => {
            this.typeList = res.data
            let data = JSON.parse(localStorage.getItem("verificationData"));
            this.question = data.questions
            for (let i = 0; i < this.question.length; i++) {
                const e = this.question[i];
                e.ischeck = false
                e.disabled = true
                e.stemPreview = e.stem.replace(/\[\[(.*?)\]\]/, '________________')
                e.attachment = {}
                let tags = []
                if (e.tags) {
                    for (let j = 0; j < e.tags.length; j++) {
                        tags.push(e.tags[j].id)
                    }
                    e.tag_ids = tags.join(',')
                }
                if (e.type === 'subjectivity') {
                    e.answer = [e.answer]
                    this.$set(e, 'submit_mode', ['text', 'attachment', 'link'])
                    this.$set(e, 'review_mode', 'manual')
                    // e.review_mode = 'manual'
                    if (e.crosshead) {
                        if (e.crosshead.length > 0) {
                            e.score = 0
                            for (let j = 0; j < e.crosshead.length; j++) {
                                const f = e.crosshead[j].score;
                                e.score += f
                            }
                        }

                    }
                }
            }
            this.overview = data.overview
            this.getErrorNum()
            this.loading = false
            this.question = data.questions
        })
    },
    methods: {
        getDownloadAddress,
        requestFullScreen() {
            let element = document.getElementById("board")
            var requestMethod = element.requestFullScreen || element.webkitRequestFullScreen || element.mozRequestFullScreen || element.msRequestFullScreen;
            if (requestMethod) {
                requestMethod.call(element);
            }
            if (typeof window.ActiveXObject !== "undefined") {
                var wscript = new ActiveXObject("WScript.Shell");
                if (wscript !== null) {
                    wscript.SendKeys("{F11}");
                }
            }
        },
        change(answer, type) {
            if (type == 'single_choice') {
                return this.letter[answer[0]]
            } else if (type == 'determine') {
                return answer[0] == 0 ? this.answerTextConfig.determine.error : this.answerTextConfig.determine.right
            } else if (type == 'choice' || type == 'uncertain_choice') {
                let arr = []
                // answer.sort()
                for (let i = 0; i < answer.length; i++) {
                    const j = answer[i]
                    arr.push(this.letter[j])
                }
                return arr.join('、')
            } else if (type == 'fill') {
                let arr = []
                for (let i = 0; i < answer.length; i++) {
                    const j = answer[i].join(' 或 ')
                    arr.push(j)
                }
                return arr.join('； ')
            }
        },
        changeTags(i) {
            if (this.tags.length > 8) {
                this.$message({
                    type: 'error',
                    message: this.formTextConfig.tooMany
                });
                this.tags = this.tags.slice(0, 8)
            }
            let name = 'cascader' + i
            let labels = this.$refs[name]
            setTimeout(() => {
                labels = labels[0].checkedNodes;
                this.question[i].tags = []
                for (let j = 0; j < labels.length; j++) {
                    if (j < 8) {
                        const e = labels[j];
                        this.question[i].tags.push({name: e.label})
                    }
                }
            }, 200);

            this.question[i].tag_ids = this.tags.join(',')
        },
        close(data) {
            this.importDialogVisible = false
            if (this.enclosure === 0) {
                this.question[this.questionIndex].attachment.stem = data
            } else if (this.enclosure === 1) {
                this.question[this.questionIndex].attachment.answer = data
            } else {
                this.question[this.questionIndex].attachment.analysis = data
            }
        },
        clickEdit(i) {
            if (this.waitSave) {
                this.waitSave = false
                this.questionIndex = i
                this.question[i].disabled = false
                this.storage = JSON.parse(JSON.stringify(this.question[i]))
                let doc = document.querySelectorAll('.el-card')[i]
                for (let i = 0; i < doc.length; i++) {
                    const e = doc.querySelectorAll('.ql-toolbar')[i];
                    e.style.display = 'none'
                }
                if (!this.question[i].answer.length) {
                    if (this.question[i].type == 'single_choice' || this.question[i].type == 'uncertain_choice') {
                        this.question[i].answer = [0]
                    } else if (this.question[i].type == 'choice') {
                        this.question[i].answer = [0, 1]
                    } else if (this.question[i].type == 'determine') {
                        this.question[i].answer = [1]
                    } else if (this.question[i].type == 'subjectivity') {
                        this.question[i].answer = ['']
                    }
                }
                if (!this.question[i].difficulty.length) {
                    this.question[i].difficulty = 'normal'
                }
                if (this.question[i].tag_ids) {
                    this.tags = this.question[i].tag_ids.split(",")
                } else {
                    this.tags = []
                }
                if (this.question[i].type == "fill") {
                    this.question[i].stem = this.question[i].stem.replace(/\[\[(.*?)\]\]/g, '________________')
                    for (let j = 0; j < this.question[i].answer.length; j++) {
                        const e = this.question[i].answer[j];
                        this.question[i].stem = this.question[i].stem.replace('________________', '[[' + e.join('|') + ']]')
                    }
                }
            } else {
                this.$message({
                    message: this.formTextConfig.noSave,
                    type: 'warning'
                });
            }
        },
        save(i) {
            // if (this.question[i].is_valid) {
            this.question[i].invalid_notice = ''
            this.question[i].is_valid = true
            this.question[i].error = []
            this.question[i].stemPreview = this.question[i].stem
            if (!this.question[i].stem.length) {
                this.question[i].error.push(this.saveTextConfig.nullStem)
                this.question[i].is_valid = false
            }
            if (this.question[i].type == 'single_choice' || this.question[i].type == 'choice' || this.question[i].type == 'uncertain_choice') {
                let choices = this.question[i].choices
                for (let j = 0; j < choices.length; j++) {
                    const e = choices[j];
                    if (e.length <= 0) {
                        this.question[i].error.push(this.saveTextConfig.choice.nullMessage.signMix(this.letter[j]))
                        this.question[i].is_valid = false
                    }
                }
                if (choices.length < 3) {
                    this.question[i].error.push(this.saveTextConfig.choice.tooLittle)
                    this.question[i].is_valid = false
                }
                if (this.question[i].type == 'choice' && this.question[i].answer.length < 2) {
                    this.question[i].error.push(this.saveTextConfig.choice.answerTooLittle)
                    this.question[i].is_valid = false
                }
                if (this.question[i].type == 'uncertain_choice' && this.question[i].answer.length < 1) {
                    this.question[i].error.push(this.saveTextConfig.choice.nullUncertain)
                    this.question[i].is_valid = false
                }
                this.question[i].answer.sort()
            } else if (this.question[i].type == 'fill') {
                this.question[i].answer = []
                let str = this.question[i].stem;
                let a = str.match(/(\[\[=?)(.*?)(?=\]\])/g)
                if (a) {
                    let err = false
                    for (let n = 0; n < a.length; n++) {
                        let e = a[n];
                        if ((e.trim()).length < 3) {
                            err = true
                        } else {
                            e = e.substring(2)
                            this.question[i].answer.push(e.split('|'))
                        }
                    }
                    if (err) {
                        this.question[i].error.push(this.saveTextConfig.fill.nullMessage2)
                        this.question[i].is_valid = false
                    } else {
                        this.question[i].stemPreview = this.question[i].stem.replace(/\[\[(.*?)\]\]/g, '________________')
                    }
                } else {
                    this.question[i].error.push(this.saveTextConfig.fill.nullMessage)
                    this.question[i].is_valid = false
                }
            } else if (this.question[i].type == 'subjectivity') {
                if (this.question[i].crosshead) {
                    for (let l = 0; l < this.question[i].crosshead.length; l++) {
                        const f = this.question[i].crosshead[l];
                        if (!f.stem.length) {
                            this.question[i].error.push(this.saveTextConfig.subjectivity.stemNullMessage.signMix(l + 1))
                            this.question[i].is_valid = false
                        }
                        if (f.score === 0) {
                            this.question[i].error.push(this.saveTextConfig.subjectivity.zeroMessage.signMix(l + 1))
                            this.question[i].is_valid = false
                        } else if (f.score === undefined) {
                            this.question[i].error.push(this.saveTextConfig.subjectivity.scoreNullMessage.signMix(l + 1))
                            this.question[i].is_valid = false
                        }
                    }
                    if (!this.question[i].crosshead.length) {
                        if (this.question[i].score === 0) {
                            this.question[i].error.push(this.saveTextConfig.scoreZeroMessage)
                            this.question[i].is_valid = false
                        } else if (this.question[i].score === undefined) {
                            this.question[i].error.push(this.saveTextConfig.scoreNullMessage)
                            this.question[i].is_valid = false
                        }
                    }
                }
                if (this.question[i].answer[0] == '' || this.question[i].answer[0] == ' ') {
                    this.question[i].error.push(this.saveTextConfig.answerNullMessage)
                    this.question[i].is_valid = false
                }
                if (this.trainingEnable) {
                    if (this.show_project_url) {
                        this.question[i].training_mirror = this.project_url;
                    }
                    if (this.question[i].training_label == null) {
                        this.question[i].error.push(this.saveTextConfig.trainingNullMessage)
                        this.question[i].is_valid = false
                    }
                    if (this.show_project_url&& this.project_url == '') {
                        this.question[i].error.push(this.saveTextConfig.projectUrlNullMessage)
                        this.question[i].is_valid = false
                    }
                    if (this.has_bill) {
                        if (this.specification_id == null ){
                            this.question[i].error.push(this.saveTextConfig.specificationNullMessage)
                            this.question[i].is_valid = false
                        }
                        if (this.gift_duration == null) {
                            this.question[i].error.push(this.saveTextConfig.giveDurationNullMessage)
                            this.question[i].is_valid = false
                        }
                        if (this.question[i].is_valid) {
                            this.question[i].training_bill = {specification_id : this.specification_id, gift_duration: this.gift_duration}
                        }

                    }
                }
                if (this.question[i].review_mode === 'script' && !this.question[i].review_script) {
                    this.question[i].error.push('脚本设置项不可为空')
                    this.question[i].is_valid = false
                }

                if (this.question[i].review_mode === 'manual' && this.question[i].submit_mode.length <= 0) {
                    this.question[i].error.push('答题方式不可为空')
                    this.question[i].is_valid = false
                }
            }
            if (this.question[i].type != 'subjectivity') {
                if (this.question[i].score === 0) {
                    this.question[i].error.push(this.saveTextConfig.scoreZeroMessage)
                    this.question[i].is_valid = false
                } else if (this.question[i].score === undefined) {
                    this.question[i].error.push(this.saveTextConfig.scoreNullMessage)
                    this.question[i].is_valid = false
                }
            }
            if (this.question[i].is_valid) {
                this.waitSave = true
                this.question[i] = this.question[i]
                this.question[i].disabled = true
            }
            document.getElementsByClassName("questionButton")[i].click()
            this.getOverview()

            // }
        },
        getErrorNum() {
            let num = 0
            for (let i = 0; i < this.question.length; i++) {
                const e = this.question[i].is_valid;
                if (!e) {
                    num += 1
                }
            }
            this.errorNum = num
        },
        cancel(i) {
            this.question[i] = this.storage
            this.waitSave = true
            this.question[i].disabled = true
            this.num += 1
        },
        clickRemove(i) {
            if (!this.question[i].disabled) {
                this.waitSave = true
            }
            let deleteTextConfig = this.formTextConfig.delete
            this.$confirm(deleteTextConfig.message, deleteTextConfig.title, {
                confirmButtonText: deleteTextConfig.ok,
                cancelButtonText: deleteTextConfig.cancel,
                type: 'warning'
            }).then(() => {
                this.$message({
                    type: 'success',
                    message: deleteTextConfig.success
                });
                this.question.splice(i, 1);
                this.getOverview()
                if (this.question.length == 0) {
                    this.$router.push({name: 'question', query: {id: this.$route.query.id}})
                }
            }).catch(() => {
            })
        },
        getOverview() {
            this.overview.question_num = this.question.length
            this.overview.single_choice_num = 0
            this.overview.choice_num = 0
            this.overview.uncertain_choice_num = 0
            this.overview.determine_num = 0
            this.overview.fill_num = 0
            this.overview.subjectivity_num = 0
            let num = 0
            for (let l = 0; l < this.question.length; l++) {
                const type = this.question[l].type;
                const valid = this.question[l].is_valid;
                if (type == 'single_choice') {
                    this.overview.single_choice_num += 1
                } else if (type == 'choice') {
                    this.overview.choice_num += 1
                } else if (type == 'uncertain_choice') {
                    this.overview.uncertain_choice_num += 1
                } else if (type == 'determine') {
                    this.overview.determine_num += 1
                } else if (type == 'fill') {
                    this.overview.fill_num += 1
                } else if (type == 'subjectivity') {
                    this.overview.subjectivity_num += 1
                }
                if (!valid) {
                    num += 1
                }
            }
            this.errorNum = num
        },
        setOperation() {
            this.operation = !this.operation
            this.select = false
            this.selectRow = []
            if (this.operation) {
                this.question.map(item => {
                    item.ischeck = false
                })
            }
        },
        clickQuestion(i) {
            // 滚动到指定位置
            const parent = document.querySelector('.left');
            const child = document.querySelector(`#questionCard${i}`);
            parent.scrollTo({top: (child.offsetTop - 180), behavior: "smooth"});

            if (this.operation) {
                if (this.question[i].ischeck) {
                    let index = this.selectRow.indexOf(this.question[i].id);
                    if (index > -1) {
                        this.selectRow.splice(index, 1);
                    }
                } else {
                    this.selectRow.push(this.question[i].id)
                }
                this.question[i].ischeck = !this.question[i].ischeck
                if (this.selectRow.length < this.question.length) {
                    this.select = false
                } else if (this.selectRow.length == this.question.length) {
                    this.select = true
                }
            }
        },
        selectAll() {
            this.select = !this.select
            this.selectRow = []
            if (this.select) {
                this.question.map(item => {
                    item.ischeck = true
                    this.selectRow.push(item.id)
                })
            } else {
                this.question.map(item => {
                    item.ischeck = false
                })
            }
        },
        openDialog(val) {
            if (this.selectRow.length > 0) {
                if (val == 0) {
                    this.difficultyDialogVisible = true
                } else {
                    this.scoreDialogVisible = true
                }
            } else {
                this.$message({
                    message: this.formTextConfig.least,
                    type: 'warning'
                });
            }
        },
        batchDelete() {
            if (this.selectRow.length > 0) {
                let deleteTextConfig = this.operateTextConfig.button.delete
                this.$confirm(deleteTextConfig.message.signMix(this.selectRow.length), deleteTextConfig.title, {
                    confirmButtonText: deleteTextConfig.ok,
                    cancelButtonText: deleteTextConfig.cancel,
                    type: 'warning'
                }).then(() => {
                    let newArr = []
                    for (let i = 0; i < this.question.length; i++) {
                        const e = this.question[i];
                        if (!e.ischeck) {
                            newArr.push(e)
                        }
                    }
                    this.selectRow = []
                    this.$message({
                        type: 'success',
                        message: deleteTextConfig.success
                    });
                    if (newArr.length) {
                        this.question = newArr
                    } else {
                        this.question = []
                        this.$router.push({name: 'question', query: {id: this.$route.query.id}})
                    }
                    this.getOverview()
                }).catch(() => {
                });
            } else {
                this.$message({
                    message: this.formTextConfig.least,
                    type: 'warning'
                });
            }
        },
        typeChange(type, i) {
            this.question[i].typeLabel = this.questionTypeFormatter(type)
            if (type == 'single_choice') {
                this.question[i].answer = [0]
            } else if (type == 'choice') {
                this.question[i].answer = [0, 1]
            } else if (type == 'uncertain_choice') {
                this.question[i].answer = [0]
            }
            this.$message({
                message: this.formTextConfig.changeMessage.signMix(this.question[i].typeLabel),
                type: 'warning'
            });
        },
        changeScore(i) {
            this.question[i].score = 2
            this.question[i].crosshead.map(e => {
                if (e.score === undefined) {
                    this.question[i].score += 0
                } else {
                    this.question[i].score += e.score
                }
            })
            this.question[i].score = this.question[i].score - 2
        },
        difficultyDialogClose(data) {
            this.difficultyDialogVisible = false
            for (let i = 0; i < this.question.length; i++) {
                const e = this.question[i];
                if (e.ischeck) {
                    e.difficulty = data
                }
            }
        },
        scoreDialogClose(data) {
            this.scoreDialogVisible = false
            let len = false
            for (let i = 0; i < this.question.length; i++) {
                const e = this.question[i];
                if (e.ischeck) {
                    if (e.type == 'subjectivity' && e.crosshead.length) {
                        len = true
                    } else {
                        e.score = data
                    }
                }
            }
            if (len) {
                setTimeout(() => {
                    this.$message({
                        message: this.saveTextConfig.subjectivity.skip,
                        type: 'warning'
                    });
                }, 400);
            }
        },
        importQuestion() {
            this.loading = true
            let confirmTextConfig = this.operateTextConfig.button.confirm
            if (this.waitSave && !this.errorNum) {
                for (let i = 0; i < this.question.length; i++) {
                    const e = this.question[i];
                    if (e.type == 'subjectivity') {
                        if (e.training_mirror == '0') {
                            e.training_mirror = ''
                        }
                    }
                }
                this.$store.dispatch("importQuestions", {
                    id: this.$route.query.id,
                    question: this.question
                }).then(res => {
                    if (res.status == 200) {
                        this.$message({
                            message: confirmTextConfig.success,
                            type: 'success'
                        });
                        localStorage.removeItem('verificationData')
                        this.$router.push({name: 'question', query: {id: this.$route.query.id}})
                        this.$route.meta.keepAlive = false
                    }
                    this.loading = false
                });
            } else {
                this.loading = false
                if (this.errorNum) {
                    this.$message({
                        message: confirmTextConfig.error.signMix(this.errorNum),
                        type: 'warning'
                    });
                } else {
                    this.$message({
                        message: this.formTextConfig.noSave,
                        type: 'warning'
                    });
                }
            }
        },
        difficultyFormatter(val) {
            let already = this.difficultyOptions.find(item => item.dict_value == val)
            return already ? already.dict_label : ''
        },
        questionTypeFormatter(val) {
            let already = this.typeList.find(item => item.dict_value == val)
            return already ? already.dict_label : ''
        },
        reviewModelFormatter(val) {
            let already = this.reviewModeOptions.find(item => item.dict_value == val)
            return already ? already.dict_label : ''
        },
        submitModeFormatter(e) {
            if (e.review_mode == 'script') {
                return "实操"
            } else {
                let ret = []
                e.submit_mode.forEach(submitMode => {
                    let already = this.submitModeOptions.find(item => item.dict_value == submitMode)
                    if (already) {
                        ret.push(already.dict_label)
                    }
                })
                return ret.join('、')
            }

        },
        reviewModeChange(i) {
            if (this.question[i].review_mode === 'script') {
                this.$set(this.question[i], 'submit_mode', [])
                let selected = this.trainingOptions.find(item => item.label === this.form.training_label)
                if (selected.platform_mark != 'ws_cloud') {
                    this.question[i].training_mirror = null
                    this.question[i].training_label = null
                    this.has_bill = false
                    this.project_url = '';
                    this.show_project_url = false
                    this.specification_id = null
                    this.gift_duration = null
                }
                this.question[i].submit_mode = []
            } else if (this.question[i].review_mode === 'manual') {
                this.question[i].submit_mode = ['text', 'attachment', 'link']
            } else if (this.question[i].review_mode === 'objective') {
                this.question[i].submit_mode = []
            }
        },
        trainingChange(val, question, i) {
            let selected = this.trainingOptions.find(item => item.label === val)
            question.platform_mark = selected ? selected.platform_mark : null
            if (selected) {
                question.training_mirror = selected.value
                this.has_bill = selected.has_bill
                if (!this.has_bill) {
                    this.specification_id = null
                    this.gift_duration = null
                }
                if (selected.platform_mark == 'external_url' && selected.value == "" ) {
                    this.show_project_url = true
                } else {
                    this.show_project_url = false
                    this.project_url = ''
                }
            } else  {
                this.has_bill = false
                this.show_project_url = false
                this.project_url = ''
                this.specification_id = null
                this.gift_duration = null
                question.training_mirror[i] = ''
            }
        },
        changeSpecification(item,question, i) {
            this.specification_id = item.id
            this.price = item.currentPrice ?item.currentPrice:item.price
            if (item.priceUnit == 'min') {
                this.priceUnitLabel = '分钟'
            } else {
                this.priceUnitLabel = '小时'
            }
            if (this.gift_duration) {
                this.tipdm_icon = this.gift_duration * this.price
                this.tipdm_icon =  this.tipdm_icon.toFixed(2)
            }

        },
        changeGiveDuration() {
            if (this.gift_duration && this.price) {
                this.tipdm_icon = this.gift_duration * this.price
                this.tipdm_icon =  this.tipdm_icon.toFixed(2)
            }
        }
    }
}
</script>

<style scoped>
.info {
    color: #C0C4CC;
    font-size: 14px;
    line-height: 20px;
    margin-top: 6px;
}

.questionCon {
    width: 100%;
    height: calc(100% - 94px);
}

.questionCon .left {
    float: left;
    padding-right: 10px;
    width: calc(100% - 288px);
    height: 100%;
    overflow: auto;
}

.questionCon .right {
    float: right;
    padding-right: 10px;
    width: 260px;
    height: 100%;
    overflow: auto;
}

.questionCon .box-card {
    margin-bottom: 10px;
    position: relative;
}

.right .el-card__body > div {
    line-height: 28px;
    font-size: 15px;
}

.right .el-card__body div span {
    float: right;
}

.questionCon .left .box-card {
    padding: 10px;
}

.left .conLeft {
    width: calc(100% - 276px);
    display: inline-block;
}

.left .conRight {
    width: 276px;
    float: right;
}

.questionCon .left .number {
    padding: 0;
    float: left;
    width: 32px;
    text-align: center;
    margin-top: 8px;
    line-height: 32px;
}

.conLeft .el-radio-group, .conLeft .el-radio, .conLeft .el-radio__inner, .conLeft .el-radio__input {
    display: block;
}

.conLeft .el-radio >>> .el-radio__input, .conLeft .el-radio >>> .el-radio__label > i {
    position: relative;
    /*top: 13px;*/
}

.el-row .el-button {
    height: 44px;
    margin-left: 10px;
}

.editModel {
    position: absolute;
    top: 0;
    right: 0;
    display: none;
}

.el-card:hover .editModel {
    display: block;
}

.editor {
    width: 100%;
}

.el-form >>> .el-form-item--small .el-form-item__content, .el-form >>> .el-form-item--small .el-form-item__label {
    line-height: 40px;
}

.preview >>> .el-form-item--small.el-form-item {
    margin-bottom: 0 !important;
}

.questionA {
    text-align: center;
    height: 50px;
    border-color: #fff;
    margin-top: 8px;
    padding: 10px;
    padding-top: 5px;
    position: relative;
}

.questionCheck {
    border-color: #0070de;
}

.questionCheck .check {
    border: 0 solid transparent;
    width: 0;
    height: 0;
    border-bottom: 25px solid #0070de !important;
    border-left: 25px solid transparent !important;
    border-radius: 0;
    position: absolute;
    bottom: 0;
    right: 0;
    z-index: 1;
}

.questionA .check i {
    color: #fff;
    position: absolute;
    bottom: -24px;
    left: -13px;
}

.questionCon span.number {
    display: block;
    margin: auto;
    width: 24px;
    padding: 6px 0;
    border-radius: 50%;
    border: 1px solid #ddd;
    position: relative;
    top: -5px;
    left: -8px;
}

.questionA p {
    position: relative;
    bottom: -23px;
}

.questionA:focus, .questionA:hover {
    border-color: #fff;
    background-color: #fff;
}

.questionA:focus span, .questionA:hover span {
    border-color: #c6e2ff;
}

.questionCheck:focus, .questionCheck:hover {
    border-color: #0070de;
    background-color: #fff;
    color: #0070de;
}

.questionCheck:focus span, .questionCheck:hover span {
    border-color: #c6e2ff;
}

.questionError {
    color: #de0000;
}

.questionError span.number {
    border-color: #f5b3b3;
}

.questionEdit {
    color: #0070de;
}

.questionEdit span.number {
    border-color: #b3d4f5;
}

.el-radio >>> .el-radio__input.is-disabled + span.el-radio__label, .el-checkbox >>> .el-checkbox__input.is-disabled + span.el-checkbox__label {
    color: #303133;
}

@media screen and (max-width: 1570px) {
    .conLeft {
        width: 100% !important;
    }

    .conRight {
        display: block;
        float: unset !important;
        margin-left: 45px;
        margin-top: 18px;
    }
}

.determine >>> .el-radio__input {
    top: -1px !important;
}

.el-radio {
    white-space: normal;
    padding-right: 20px;
}

.specifications-list-container {
    background: #f4f5f9;
    padding: 20px 30px 5px 30px;
}

ul.specifications-list {
    display: flex;
    padding-left: 0;
    flex-wrap: wrap;
    max-height: 438px;
    overflow-y: auto;
}
ul.specifications-list li {
    list-style: none;
    box-sizing: border-box;
    border: 1px solid #e1e1e1;
    border-radius: 4px;
    padding: 6px 20px;
    margin-right: 20px;
    margin-bottom: 12px;
    width: 250px;
    height: 150px;
    color: #000;
    cursor: pointer;
    line-height: 16px;
    padding: 15px;
    background: #fff;
}
ul.specifications-list li:nth-child(3n) {
    margin-right: 0px;
}
ul.specifications-list li > h5 {
    font-size: 20px;
    white-space: nowrap; /* 不换行 */
    overflow: hidden; /* 超出部分隐藏 */
    text-overflow: ellipsis; /* 显示省略号 */
    line-height: 35px;
    margin-bottom: 10px;
}
ul.specifications-list li > p {
    margin: 0 0 4px;
}
ul.specifications-list li > p .label {
    color: rgba(0, 0, 0, .56);
}
ul.specifications-list li.selected {
    border-color: #99c6f2;
    position: relative;
}
ul.specifications-list li.selected h5 {
    color: #000;
}
ul.specifications-list li .selected-icon {
    display: none;
}
ul.specifications-list li.selected .selected-icon {
    display: block;
    position: absolute;
    top: 1px;
    right: 0;
    color: #fff;
    z-index: 111;
}
ul.specifications-list li.selected:after {
    content: '';
    display: block;
    top: 0;
    right: 0;
    background: #99c6f2;
    position: absolute;
    width: 30px;
    height: 30px;
    clip-path: polygon(0 0, 30px 0, 30px 30px);
}
.subjectivity .questIndex {
    display: inline-block;
    line-height: 50px;
    float: left;
    font-size: 14px;
    width: 48px;
}
</style>
